import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BackButton from '@/components/BackButton.vue';
import CharacterPrintPage1 from './CharacterPrintPage1';
import CharacterPrintPage2 from './CharacterPrintPage2';
import CharacterPrintPage3 from './CharacterPrintPage3';
import CharacterPrintPage4 from './CharacterPrintPage4';
const characterModule = namespace('character');
let CharacterPrint = class CharacterPrint extends Vue {
    constructor() {
        super(...arguments);
        this.playerName = '';
    }
    get myClasses() {
        return (this.$style);
    }
    get completeCharacter() {
        const rawCharacter = this.getCharacterById(this.characterId);
        return rawCharacter ? this.generateCompleteCharacter(rawCharacter) : null;
    }
    get pages() {
        return this.completeCharacter ? [
            CharacterPrintPage1(this.completeCharacter, this.myClasses, this.playerName),
            CharacterPrintPage2(this.completeCharacter, this.myClasses),
            CharacterPrintPage3(this.completeCharacter, this.myClasses),
            ...CharacterPrintPage4(this.completeCharacter)
        ] : [];
    }
    setStyle({ top, left, width, height, fontSize }) {
        return {
            top: top + 'px',
            left: left + 'px',
            width: width + 'px',
            height: height + 'px',
            ...(fontSize ? { 'font-size': fontSize + 'px' } : {})
        };
    }
    print() {
        window.print();
    }
};
__decorate([
    Prop(String)
], CharacterPrint.prototype, "characterId", void 0);
__decorate([
    characterModule.Getter
], CharacterPrint.prototype, "generateCompleteCharacter", void 0);
__decorate([
    characterModule.Getter
], CharacterPrint.prototype, "getCharacterById", void 0);
CharacterPrint = __decorate([
    Component({
        components: {
            BackButton
        }
    })
], CharacterPrint);
export default CharacterPrint;
